import get from 'lodash/get';
import {
  FETCH_ALL_WRANGLERS,
  FETCH_MARKET_WRANGLERS,
  WRANGLERS_LOADING,
  SET_ACTIVE_WRANGLER,
} from '../actions/wranglers';
import { WranglerStatuses } from '../lib/utils';

import getAccess from '../access';

export default function(state = {}, action) {
  switch (action.type) {
    case FETCH_ALL_WRANGLERS:
      return {
        ...state,
        wranglers: action.payload,
      };
    case FETCH_MARKET_WRANGLERS: {
      const marketWranglers = get(action, 'payload', []);
      const activeMarketWranglers = marketWranglers.filter(
        (wrangler) => wrangler.status === WranglerStatuses.ACTIVE,
      );
      return {
        ...state,
        marketWranglers,
        activeMarketWranglers,
      };
    }
    case WRANGLERS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case SET_ACTIVE_WRANGLER: {
      const currentWrangler = action.payload;
      currentWrangler.access = getAccess(currentWrangler);
      currentWrangler.access.can = currentWrangler.access.can.bind(currentWrangler.access);
      return {
        ...state,
        currentWrangler,
      };
    }
    default:
      return state;
  }
}
